// Import libraries
import React from 'react';
import ReactDOM from 'react-dom';

// Import app
import App from './App';

// Import service worker
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

// Unregister the service worker
serviceWorker.unregister();
